import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { logError } from './utils/error';

function BoundaryFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="p-6 text-sm h-full flex flex-col gap-4" style={{ background: 'var(--bg-surface)', color: 'var(--danger)' }}>
      <div>
        <h1 className="text-lg font-semibold mb-1">Application Error</h1>
        <p className="text-xs opacity-80">An unexpected error occurred. You can try to recover.</p>
      </div>
      <pre className="whitespace-pre-wrap text-xs p-2 rounded bg-black/5 dark:bg-white/5 max-h-40 overflow-auto" style={{ border: '1px solid var(--border)' }}>{error.message}</pre>
      <div className="flex gap-2">
        <button className="px-3 py-1.5 rounded text-xs font-medium bg-indigo-600 text-white hover:bg-indigo-500" onClick={resetErrorBoundary}>Retry</button>
        <button className="px-3 py-1.5 rounded text-xs font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600" onClick={() => window.location.reload()}>Reload Page</button>
      </div>
    </div>
  );
}

export const AppBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ErrorBoundary
    FallbackComponent={BoundaryFallback}
    onError={(e, info) => {
      logError(e, { where: 'AppBoundary', componentStack: info?.componentStack });
    }}
  >
    {children}
  </ErrorBoundary>
);
